import React, { useContext } from "react";
import { Redirect } from "react-router-dom";
import { AuthContext } from "src/context/Auth";

const isTokenExpired = (token) => {
  if (!token) {
    return true;
  }

  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    const expirationTime = payload?.exp ? payload.exp * 1000 : 0;
    return !expirationTime || Date.now() >= expirationTime;
  } catch (error) {
    return true;
  }
};

export default function AuthGuard(props) {
  const { children } = props;
  const token = sessionStorage.getItem("adminToken");
  const auth = useContext(AuthContext);
  const tokenExpired = isTokenExpired(token);

  if (!token || tokenExpired) {
    sessionStorage.removeItem("adminToken");
    sessionStorage.removeItem("userType");
    sessionStorage.removeItem("creatturAccessToken");
    return <Redirect to="/" />;
  }

  if (!auth.userLoggedIn) {
    return <Redirect to="/" />;
  }

  return <>{children}</>;
}
